import styled from 'styled-components';

const CardHeader = styled.div`
  padding: ${({ theme }) => theme.spacing.medium || '0.9375rem'} ${({ theme }) => theme.spacing.large || '1.25rem'};
  background: #f8f9fa; /* Neutral light background for modern look */
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.3s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.brandBackground || 'rgba(130, 22, 146, 0.05)'}; /* Subtle hover effect */
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile || '768px'}) {
    padding: ${({ theme }) => theme.spacing.small || '0.625rem'};
  }
`;

export default CardHeader;
